import Core from '../Core'

export default (superclass) => class extends superclass {
  burnUniqCode () {
    return Core.publicWrapper({
      name: 'burnUniqCode',
      arguments: arguments,
      parameters: ['code', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        {
          name: 'code',
          presence: true,
          type: 'string',
        },
      ],
    })
  }
  linkCodeToUserInformation () {
    return Core.publicWrapper({
      name: 'linkCodeToUserInformation',
      arguments: arguments,
      parameters: ['userInformationFields', 'codeId', 'receiptId', 'productShotImageKey', 'receiptKitUuid', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        {
          name: 'userInformationFields',
          presence: true,
          type: 'object',
        },
        {
          name: 'codeId',
          presence: true,
          type: 'number',
        },
        {
          name: 'receiptId',
          type: 'number',
        },
        {
          name: 'receiptKitUuid',
          type: 'string',
        },
        {
          name: 'productShotImageKey',
          type: 'string',
        }
      ],
    })
  }
  linkCodeToReceipt () {
    return Core.publicWrapper({
      name: 'linkCodeToReceipt',
      arguments: arguments,
      parameters: ['codeId', 'receiptKitUuid', 'onSuccess', 'onFailure', 'onComplete', 'productShotImageKey'],
      validations: [
        {
          name: 'codeId',
          presence: true,
          type: 'number',
        },
        {
          name: 'receiptKitUuid',
          presence: true,
          type: 'string',
        },
        {
          name: 'productShotImageKey',
          type: 'string',
        }
      ],
    })
  }

  allOrders () {
    return this._publicWrapperWithoutParameter('allOrders', arguments)
  }
}
